import React, { useEffect, useState } from "react"
import { Pencil, ChevronRight, ChevronDown, Plus, Save, X } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { cn, randoms } from "lib/utils";
import { findById, updateById, save } from "lib/utils/apiHelpers"
import { InputField } from "lib/components"
import { ELEMENTS, RULES_ACTIONS, sortArrayOfObjects } from "lib/utils"
import { useRulesEngineCtx } from ".";



export default function ReplaceRuleFields({
  action,
  handleRuleFormChange
}:{
  action: any,
  handleRuleFormChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
}){

  const { engineState, setEngineState } = useRulesEngineCtx() 

  useEffect(() => {
    console.log(action)
  },[action])
  /*
   } else if( e.target.name.startsWith("action:") ){
      const editProp = e.target.name.split(":")[1]
      const refstr = e.target.name.split(":")[2]
      const newActions = engineState.selectedRule.rule.actions.map( (act:any) => { 
        if( act.refstr === refstr ){
          return { ...act, [editProp]: e.target.value }
        }
        return act
      })
  */ 

  return (
    <div className="w-full flex my-1 px-[4px] gap-3">
      <InputField 
        className="w-3/12 text-xs" 
        name={`action:replaceLabel:${action.refstr}`}
        placeholder="enter new label" 
        value={action.replaceLabel || ""} 
        onChange={handleRuleFormChange}
      />
      <InputField 
        className="w-9/12 text-xs" 
        name={`action:replaceWith:${action.refstr}`} 
        placeholder="enter new data path" 
        value={action.replaceWith || ""} 
        onChange={handleRuleFormChange} 
      />
    </div>
  )
}